import {
  DB_FEE_SUCCESS,
  DB_FEE_FAILED,
  DB_FEE_NETWORK_ERROR,
  DB_FEE_RESET
} from "../types";

const initialState = {
  success: false,
  failed: false,
  data: "",
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {

    case DB_FEE_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.payload,
        networkError: ""
      };

    case DB_FEE_FAILED:
      return {
        ...state,
        success: false,
        failed: true,
        data: action.payload,
        networkError: ""
      };

    case DB_FEE_NETWORK_ERROR:
      return {
        ...state,
        failed: false,
        success: false,
        data: "",
        networkError: "Something went wrong..Check network connectivity"
      };

    case DB_FEE_RESET:
      return (state = initialState);

    default:
      return state;
  }
};
